<template>
  <div class="login section fullscreen-content">
    <div class="container">

      <div class="auth-form zoomIn">
        <form-heading></form-heading>
        <div class="form-field">
          <input
            type="text"
            v-validate="'required|email'"
            name="email"
            class="form-input"
            v-model="email"
            :placeholder="$t('auth.email')"
          />
          <span>{{ errors.first('email') }}</span>
        </div>
        <div class="form-field">
          <input
            type="password"
            v-validate="'required'"
            name="password"
            class="form-input"
            v-model="password"
            :placeholder="$t('auth.password')"
          />
          <span>{{ errors.first('password') }}</span>
        </div>
        <div class="form-field auth-actions">
          <div class="row between">
            <div class="col">
              <input type="checkbox" v-model="remember" class="checkbox" id="remember" />
              <label for="remember">{{$t('auth.remember_me')}}</label>
            </div>
            <div class="col">
              <router-link :to="{name: 'forgot-password'}">{{$t('auth.forgot_password')}}</router-link>
            </div>
          </div>
        </div>
        <div class="form-field">
          <button
            class="button"
            @click="login()"
            :disabled="loading"
            :class="{ loading: loading }"
          >{{$t('auth.sign_in')}}</button>
          <span v-if="message != ''" class="form-response" :class="responseType">{{ $t(message) }}</span>
        </div>
        <div class="form-field social-login">
          <p>{{$t('auth.social_connect')}}</p>
          <button class="button light dark-bordered"><i class="icon-facebook"></i> {{$t('auth.fb_sign_in')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service'
import FormHeading from '@/components/shop/auth/AuthFormHeading'
export default {
  name: 'login',
  components: {
    FormHeading
  },
  i18n: {
    messages: {
      en: {
        your_name: "Your name",
        email_address: "E-mail address",
        enquiry: "Enquiry",
        submit: "SUBMIT",
        auth: {
          user_not_found: "Username or password is invalid",
        },
        please_check_the_fields: "PLease check the fields"
      },
      hy: {
        your_name: "Անուն",
        email_address: "Էլ․ փոստ",
        enquiry: "Նամակ",
        submit: "ՈՒՂԱՐԿԵԼ",
        auth: {
          user_not_found: "Էլ․ փոստը կամ գաղտնաբառը սխալ են",
        },
        please_check_the_fields: "Խնդրում ենք ստուգել դաշտերը"
      }
    }
  },
  data () {
    return {
      email: '',
      password: '',
      remember: false,
      activeForm: 'sign-in',
      message: '',
      responseType: '',
      loading: false
    }
  },
  created () {
    if (this.$store.state.auth.is_auth) {
      this.$router.push('/')
    }
  },
  methods: {
    resetResponse () {
      this.message = '';
      this.responseType = '';
    },
    setResponse (type, message) {
      this.message = message
      this.responseType = type
    },
    login () {
      if (!this.loading) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.message = '';
            this.responseType = '';
            this.loading = true
            Api.post('/login', {
              email: this.email,
              password: this.password,
              remember: this.remember
            })
              .then(response => {
                var self = this
                self.$store.dispatch('fetchAuth', response.data.user)
                window.localStorage.setItem(
                  'id_token',
                  response.data.user.token
                )
                window.location.href = '/' + this.$i18n.locale
              })
              .catch(error => {
                console.log(error)
                this.responseType = 'error';
                this.loading = false
                if (error.response.status == 419) {
                  this.message = 'Please wait. Page reloading.';
                  window.location.href = '/sign-in';
                } else {
                  this.setResponse('error', 'please_check_the_fields')
                  for (var key in error.response.data) {
                    this.errors.add({
                      field: key,
                      msg: this.$t('auth.' + error.response.data[key])
                    })
                    this.$validator.flag(key, {
                      invalid: true
                    })
                  }
                }
              })
          } else {
            console.log(result)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.login {
  padding-top: 130px;
}
</style>
